import { render, staticRenderFns } from "./SendMatchDialog.vue?vue&type=template&id=8ff467f6&scoped=true"
import script from "./SendMatchDialog.vue?vue&type=script&lang=js"
export * from "./SendMatchDialog.vue?vue&type=script&lang=js"
import style0 from "./SendMatchDialog.vue?vue&type=style&index=0&id=8ff467f6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff467f6",
  null
  
)

export default component.exports